import { render, staticRenderFns } from "./CollegeScore.vue?vue&type=template&id=1d6a90cc&scoped=true"
import script from "./CollegeScore.vue?vue&type=script&lang=js"
export * from "./CollegeScore.vue?vue&type=script&lang=js"
import style0 from "./CollegeScore.vue?vue&type=style&index=0&id=1d6a90cc&prod&scoped=true&lang=less"
import style1 from "./CollegeScore.vue?vue&type=style&index=1&id=1d6a90cc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6a90cc",
  null
  
)

export default component.exports